import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import NProgress from 'nprogress'

import App from '@/App'
import Home from '@/components/Home'
const Ayusa = () => import('@/components/work/Ayusa')
const Aupaircare = () => import('@/components/work/Aupaircare')
const Globalinternships = () => import('@/components/work/Globalinternships')
const Aptozen = () => import('@/components/work/Aptozen')
const Contact = () => import('@/components/Contact')
const Thanks = () => import('@/components/Thanks')
const Creative = () => import('@/components/Creative')
const Notfound = () => import('@/components/NotFound')

Vue.use(Router)
Vue.use(Meta)

NProgress.configure({
  template: '<div class="bar" role="bar" style="display: none"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
});

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: App,
      children: [
        {
          path: '',
          name: 'Home',
          component: Home,
          meta: {
            title: 'projects'
          },
          children: [
            {
              path: 'thanks',
              name: 'Thanks',
              component: Thanks
            }
          ]
        },
        {
          path: '/ayusa',
          name: 'Ayusa',
          component: Ayusa
        },
        {
          path: '/aupaircare',
          name: 'Aupaircare',
          component: Aupaircare
        },
        {
          path: '/global_internships',
          name: 'Globalinternships',
          component: Globalinternships
        },
        {
          path: '/aptozen',
          name: 'Aptozen',
          component: Aptozen
        },
        {
          path: '/contact',
          name: 'Contact',
          component: Contact
        },
        {
          path: '/creative',
          name: 'Creative',
          component: Creative
        }
      ]
    },
    {
      path: '/404',
      name: 'NotFound',
      component: Notfound
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // graceful scroll-up behavior for page transitions
    let position = { x: 0, y: 0 }
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(position)
      }, 500)
    })
  }
})

// loading progress bar
router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start()
  }

  next()
})

router.afterEach((to, from) => {
  NProgress.done()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js